var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#3463CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 50C32.433 50 34 48.433 34 46.5C34 44.567 32.433 43 30.5 43C28.567 43 27 44.567 27 46.5C27 48.433 28.567 50 30.5 50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.325 39H30.675C31.1414 38.9792 31.5849 38.7765 31.9229 38.4296C32.2609 38.0828 32.4705 37.6154 32.5125 37.1145L34 14.771C34 13.7709 33.6313 12.8117 32.9749 12.1045C32.3185 11.3973 31.4283 11 30.5 11C29.5717 11 28.6815 11.3973 28.0251 12.1045C27.3687 12.8117 27 13.7709 27 14.771L28.4875 37.1145C28.5295 37.6154 28.7391 38.0828 29.0771 38.4296C29.4151 38.7765 29.8586 38.9792 30.325 39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.37b82d75af604bc1b3b5ee625c4a689b.svg";
export { ForwardRef as ReactComponent };